import { CircularProgress as CircularProgressMui, styled } from '@mui/material';

export const OuterWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
`;

export const LoaderWrapper = styled('div')`
  position: relative;
  display: inline-flex;
`;

export const BackgroundCircularProgress = styled(CircularProgressMui)(({ theme }) => ({
  color: theme.palette.other.informationLight,
}));

export const CircularProgress = styled(CircularProgressMui)(({ theme }) => ({
  color: theme.palette.primary.main,
  position: 'absolute',
  left: 0,
  strokeLinecap: 'round',
}));
